import React from "react";
import { Link } from "react-router-dom";
import styles from "./Navigation.module.css";
import * as Fa from "react-icons/fa";

function Navigation(props) {
  return (
    <nav
      className={
        `${styles.navigation} ` + `${props.checked ? styles.checked : ""}`
      }
    >
      <ul className={styles.NavigationList}>
        <li className={styles.navigation__item}>
          <Link to="/Products" className={styles.navigation__link}>
            Products
          </Link>
          <div  className={styles.Icon} >
            <Fa.FaGreaterThan />
          </div>
        </li>
        <li className={styles.navigation__item}>
          <Link to="/Occasions" className={styles.navigation__link}>
            Occasions
          </Link>
          <div className={styles.Icon} >
            <Fa.FaGreaterThan/>
          </div>
        </li>
        <li className={styles.navigation__item}>
          <Link to="Customer-Services" className={styles.navigation__link}>
            Customer Services
          </Link>
          <div className={styles.Icon} >
            <Fa.FaGreaterThan />
          </div>
        </li>
        <li className={styles.navigation__item}>
          <Link to="Customer-Services/Reviews" className={styles.navigation__link}>
            REVIEWS
          </Link>
          <div className={styles.Icon} >
            <Fa.FaGreaterThan/>
          </div>
        </li>
        <li className={styles.navigation__item}>
          <Link to="/" className={styles.navigation__link}>
            Home
          </Link>
          <div className={styles.Icon} >
            <Fa.FaGreaterThan/>
          </div>
        </li>
      </ul>
      <div className={styles.Copywrite}>Matchhampers (Jersey) Ltd. © 2025</div>
    </nav>
  );
}

export default Navigation;
